import { useTranslation } from 'react-i18next';

const DamageLegend = () => {
  const { t } = useTranslation('utils');
    return (
      <div style={styles.legend}>
        <div style={styles.title}>{t("legend.landloss")}</div>
  
        <div style={styles.item}>
          <span style={{ ...styles.color, background: "rgba(0,170,0,0.7)" }} />
          <span>~ 10% </span>
        </div>
  
        <div style={styles.item}>
          <span style={{ ...styles.color, background: "rgba(255,153,0,0.7)" }} />
          <span>10% ~ 20%</span>
        </div>
  
        <div style={styles.item}>
          <span style={{ ...styles.color, background: "rgba(255,0,0,0.7)" }} />
          <span>20% ~</span>
        </div>
      </div>
    );
  };
  
  const styles = {
    legend: {
      position: "absolute",
      left: 16,
      bottom: 16,
      background: "#2B2E3A",
      color:"#ffffff",
      padding: "12px 14px",
      borderRadius: 8,
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      fontSize: 13,
      zIndex: 1000
    },
    title: {
      fontWeight: 700,
      marginBottom: 8
    },
    item: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      marginBottom: 6
    },
    color: {
      width: 14,
      height: 14,
      borderRadius: 3
    }
  };
  
  export default DamageLegend;
  